export default {"src":"/_next/static/image/public/images/ic_btn_consult_a_doctor.e846f222364869ebd01645ffea7d1189.svg","height":48,"width":48};